/** Shared shapes for programmatic SEO registries (safe zones, sizes, fps pairs, templates, export settings). */

/** Official source only (platform help center, developer docs, vendor manual). */
export interface SourceRef {
  label: string;
  url: string;
}

/** ISO date (YYYY-MM-DD) + what changed. */
export interface ChangelogEntry {
  date: string;
  change: string;
}

export type PublishStatus = 'verified' | 'draft';

export interface PseoFaq {
  question: string;
  answer: string;
}

export interface PseoEntryBase {
  slug: string;
  primaryQuery: string;
  sourceUrls: SourceRef[];
  /** ISO date the values were last checked against `sourceUrls`. */
  lastVerified: string;
  status: PublishStatus;
  changelog: ChangelogEntry[];
  faqs: PseoFaq[];
}

/** Draft entries and entries without an official source are never rendered, linked or put in the sitemap. */
export const isPublishable = (entry: PseoEntryBase) => entry.status === 'verified' && entry.sourceUrls.length > 0;

/** Pixel rectangle on a spec canvas. */
export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
  label?: string;
}
